<template>
    <div class="aliPayWrap fc ac">
        <img class="ico" src="../../../static/imgs/movie/aliPay.png" alt />
        <span class="txt">支付宝</span>
        <p class="notice grey">由于微信限制，请选择“在浏览器中打开”</p>
        <button @click="payment" class="payment">去支付</button>
        <div v-if="isWeixin" class="layer">
            <div class="hint fc">
                <p>请点击右上角的菜单按钮</p>
                <p>选择“在浏览器中打开”</p>
            </div>
            <img class="arrowIco" src="../../../static/imgs/movie/arrow.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tradeno: this.$route.query.tradeno,
            isWeixin: false
        };
    },
    components: {},
    created() {
        let ua = navigator.userAgent.toLowerCase();
        this.isWeixin = ua.indexOf("micromessenger") != -1 ? true : false;
    },
    methods: {
        payment(){
            window.location.href = 'http://innerapi.dumovie.com/payTemp?tradeno=' + this.tradeno; 
        }
    }
};
</script>
<style scoped lang="scss">
.ico {
    width: 90px;
    height: 90px;
    margin-top: 120px;
}
.txt {
    font-size: 28px;
    margin: 20px 0;
}
.notice {
    font-size: 28px;
    margin-top: 100px;
}
.payment {
    width: 670px;
    height: 80px;
    font-size: 30px;
    border-radius: 10px;
    color: #fff;
    background: #00AAEF;
    margin-top: 200px;
    // position: fixed;
    // bottom: 80px;
}
.layer {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.65);
    position: fixed;
    top: 0;
    z-index: 5;
    .hint {
        position: absolute;
        top: 180px;
        right: 200px;
        color: #fff;
        font-size: 28px;
        p {
            line-height: 50px;
        }
    }
    .arrowIco {
        position: absolute;
        top: 50px;
        right: 50px;
        width: 116px;
        height: 112px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/order/preAliPay.vue